<template>
  <i
    class="vui-ico"
    :style="{
      width: `${w}px`,
      height: `${w}px`,
      lineHeight: `${lh? lh : w}px`,
      fontSize: `${fs? fs: w}px`,
    }"
  ></i>
</template>

<script>
export default {
  name: 'VuiIco',
  props: {
    w: {
      type: Number,
      default: 24,
    },
    lh: {
      type: Number,
    },
    fs: {
      type: Number,
    },
  },
}

</script>

<style lang="scss">
  .vui-ico {
    display: inline-block;
    text-align: center;
    vertical-align: top;
  }

</style>
